import ON_THE_BEACH_AGENCY_IDS from '../../common/auth/onTheBeachAgencyIds';

class myBookingService {
    constructor($resource, $q, CONFIG) {
        'ngInject';
        this.resource = {
            "booking": $resource(`${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference`, {}, {
                get: {
                    method: 'GET',
                    params: {
                        referenceType: '@referenceType',
                        'agencyIds[]': '@agencyIds'
                    }
                }
            }),
            "amendBooking": $resource(`${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference/amend`, {}, {
                get: {
                    method: "GET"
                },
                put: {
                    method: "PUT"
                }
            }),
            "cancelBooking": $resource(`${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference/cancel`),
            "cancelTransfer": $resource(`${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference/transfers/:transferId/cancel`),
            "goldprotection": $resource(`${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference/goldprotection`),
            "lastPdfVoucherUrl": `${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference/voucher?access_token=:accessToken`,
            "invoice": $resource(`${CONFIG.apiMyBooking.baseUrl}/bookings/:bookingReference/invoices`, {}, {
                get: {
                    method: "GET"
                },
                post: {
                    method: "POST"
                }
            }),
        };
        this.$q = $q;
    }

    getGlobalInfoBooking(bookingReference, isOnTheBeach = false) {
        const params = { bookingReference };

        if (isOnTheBeach) {
            params.referenceType = 'agency';
            params['agencyIds[]'] = ON_THE_BEACH_AGENCY_IDS;
        }

        return this.resource.booking.get(params).$promise;
    }

    getLastPdfVoucherUrl(bookingReference, accessToken, isOnTheBeach = false) {
        let url = this.resource.lastPdfVoucherUrl
            .replace(':bookingReference', bookingReference)
            .replace(':accessToken', accessToken);

        if (isOnTheBeach) {
            url += `&referenceType=agency${ON_THE_BEACH_AGENCY_IDS.map(id => `&agencyIds[]=${id}`).join('')}`;
        }
        return url;
    }

    getAmend(bookingReference) {
        return this.resource.amendBooking.get({bookingReference}).$promise;
    }

    saveAmend(bookingReference, data) {
        return this.resource.amendBooking.put({bookingReference}, data).$promise;
    }

    getCancel(bookingReference) {
        return this.resource.cancelBooking.get({bookingReference}).$promise;
    }

    postCancelBooking(bookingReference) {
        return this.resource.cancelBooking.save({bookingReference}, {}).$promise;
    }

    postCancelTransfer(bookingReference, transferId) {
        return this.resource.cancelTransfer.save({bookingReference, transferId}, {}).$promise;
    }

    postGoldProtectionUpgrade(bookingReference) {
        return this.resource.goldprotection.save({bookingReference}, {}).$promise;
    }

    getBookingInvoices(bookingReference) {
        return this.resource.invoice.get({bookingReference}).$promise;
    }

    createInvoice(bookingReference, customerDetails) {
        return this.resource.invoice.post({bookingReference}, customerDetails).$promise;
    }

}

export default myBookingService;



// WEBPACK FOOTER //
// ./client/app/api/mybooking/mybooking.service.js